export default function Style(){
  return (
    <style>
      {`
       /* // .galleryIframe {
//   height: 1090px;
// } */
@media Screen and(min-width:320px) {
  .galleryIframe {
    height: 377rem;
  }
}
@media Screen and(min-width:330px) {
  .galleryIframe {
    height: 400rem;
  }
}
@media Screen and(min-width:340px) {
  .galleryIframe {
    height: 405rem;
  }
}
@media Screen and(min-width:350px) {
  .galleryIframe {
    height: 420rem;
  }
}
@media Screen and(min-width:360px) {
  .galleryIframe {
    height: 430rem;
  }
}
@media Screen and(min-width:380px) {
  .galleryIframe {
    height: 480rem;
  }
}
@media Screen and(min-width:410px) {
  .galleryIframe {
    height: 130rem;
  }
}

@media Screen and(min-width:430px) {
  .galleryIframe {
    height: 140rem;
  }
}
@media Screen and(min-width:450px) {
  .galleryIframe {
    height: 143rem;
  }
}

@media Screen and(min-width:460px) {
  .galleryIframe {
    height: 146rem;
  }
}
@media Screen and(min-width:480px) {
  .galleryIframe {
    height: 150rem;
  }
}
@media Screen and(min-width:490px) {
  .galleryIframe {
    height: 155rem;
  }
}

@media Screen and(min-width:500px) {
  .galleryIframe {
    height: 165rem;
  }
}

@media Screen and(min-width:510px) {
  .galleryIframe {
    height: 165rem;
  }
}
@media Screen and(min-width:520px) {
  .galleryIframe {
    height: 165rem;
  }
}

@media Screen and(min-width:530px) {
  .galleryIframe {
    height: 175rem;
  }
}

@media Screen and(min-width:540px) {
  .galleryIframe {
    height: 180rem;
  }
}

@media Screen and(min-width:550px) {
  .galleryIframe {
    height: 180rem;
  }
}

@media Screen and(min-width:560px) {
  .galleryIframe {
    height: 180rem;
  }
}

@media Screen and(min-width:570px) {
  .galleryIframe {
    height: 180rem;
  }
}
@media Screen and(min-width:580px) {
  .galleryIframe {
    height: 190rem;
  }
}

@media Screen and(min-width:590px) {
  .galleryIframe {
    height: 190rem !important;
  }
}

@media Screen and(min-width:630px) {
  .galleryIframe {
    height: 200rem !important;
  }
}

@media Screen and(min-width:650px) {
  .galleryIframe {
    height: 210rem !important;
  }
}
@media Screen and(min-width:690px) {
  .galleryIframe {
    height: 220rem !important;
  }
}
@media Screen and(min-width:710px) {
  .galleryIframe {
    height: 232rem !important;
  }
}
@media Screen and(min-width:748px) {
  .galleryIframe {
    height: 250rem !important;
  }
}
@media Screen and(min-width:768px) {
  .galleryIframe {
    height: 246rem !important;
  }
}

@media Screen and(min-width:864px) {
  .galleryIframe {
    height: 1200px !important;
  }
}

@media Screen and(min-width:920px) {
  .galleryIframe {
    height: 1320px !important;
  }
}

@media Screen and(min-width:1024px) {
  .galleryIframe {
    height: 1280px !important;
  }
}

@media Screen and(min-width:1280px) {
  .galleryIframe {
    height: 95rem !important;
  }
}

        `}
    </style>
  );
}
